<template>
  <!-- eslint-disable-next-line vue/no-undef-components -- Baseline eslint ignore please fix if working on this-->
  <popper-card :custom-trigger="true" :placement="placement" :global="global">
    <template #default="{ toggle }">
      <a class="pointer" @click.prevent="toggle">
        <slot name="btn" />
      </a>
    </template>
    <template #title>
      {{ title }}
    </template>
    <template #content>
      <slot name="popper" />
    </template>
  </popper-card>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: '',
    },
    placement: {
      type: String,
      default: 'left',
    },
    global: {
      type: Boolean,
      default: false,
    },
  },
}
</script>
